





































import Plyr from "plyr";
import vClickOutside from "v-click-outside";
/* eslint-disable */
import {
  createComponent,
  onMounted,
  watch,
  onUnmounted,
  ref,
  Ref
} from "@vue/composition-api";
/* eslint-enable */

interface PlyrWrapperProps {
  url: string;
  value: boolean;
}

export default createComponent({
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    url: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  setup(props: PlyrWrapperProps, { emit }) {
    const frameRef = ref(null) as Ref<HTMLElement>;
    let player: Plyr | undefined;
    onMounted(() => {
      player = new Plyr("#player");
    });

    onUnmounted(() => player && player.destroy());

    const handleClickAway = () => {
      emit("close", false);
    };

    watch(
      () => props.value,
      newval => {
        if (newval === false) {
          player && player.pause();
        }
      }
    );
    watch(
      () => props.url,
      () => {
        if (player) {
          player.source = {
            type: "video",
            sources: [
              {
                src: props.url,
                provider: "youtube"
              }
            ]
          };
        }
      }
    );

    return {
      handleClickAway,
      frameRef
    };
  }
});
